module.exports = __webpack_public_path__ + "img/oursolution3.9546aa1a_new.7ccc1804.png";